/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ExecutionTypes {
    Base = '0',
    Manual = 1,
    Planned = 2,
    Triggered = 4,
    Adhoc = 8,
}
